import { FC, useCallback, useMemo } from 'react';
import { Breadcrumbs, Typography } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import classNames from 'classnames';

import { RoutePath } from '../../../../../constants/RoutePath';

import './Breadcrumb.less';

export interface IBreadCrumbItem {
  label: string;
  path?: RoutePath | string;
}

interface IComponentProps {
  items: IBreadCrumbItem[];
  hideNavToPrev?: boolean,
}

const Breadcrumb: FC<IComponentProps> = ({
  items = [],
  hideNavToPrev = false,
}) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const prevValue = useMemo(() => {
    const index = items.findLastIndex((item) => !item.path);
    return index > 0 ? index - 1 : index;
  }, [pathname, items]);

  const navigateToPrev = useCallback(() => {
    const path = items[prevValue]?.path;
    if (path) {
      navigate(path);
    }
  }, [items, prevValue]);

  return (
    <>
      {!hideNavToPrev && (
      <FontAwesomeIcon
        icon={faChevronLeft}
        className="breadcrumb__back-btn"
        onClick={navigateToPrev}
      />
      )}
      <Breadcrumbs aria-label="breadcrumb" className="breadcrumb">
        {items.map((item, index) => (
          item.path ? (
            <Link
              key={item.path}
              to={item.path}
              className="breadcrumb__item"
            >
              {item.label}
            </Link>
          ) : (
            <Typography key={item.label} className={classNames('breadcrumb__item', { selected: index === items.length - 1 })}>
              {item.label}
            </Typography>
          )
        ))}
      </Breadcrumbs>
    </>
  );
};

export default Breadcrumb;
